import React, { useState } from 'react';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { notification } from 'src/components/Notification';
import PublicSurveyPageStyle from 'src/pages/PublicSurveyPage/PublicSurveyPage.styles';
import { useStartSurveyExecution } from './hooks';
import fingerprintInfo from './utils/fingerprint';
import { setSurveyResult } from './utils/localStorage';
import S from './PublicSurveyIntro.styles';
import PublicSurveyLanguage from './PublicSurveyLanguage';

const PublicSurveyIntro = props => {
  const {
    surveyLinkToken,
    setIsSecondResponseError,
    setSurveyState,
    setSurveyExecutionHash,
    setShowSurveyIntro,
    showSurveyIntro,
    surveySkin,
    showSurveyLanguage,
    setShowSurveyLanguage,
    availableLanguages,
    setSelectedLanguage,
    selectedLanguage,
    onLanguageNext,
    getSkinWithSupportedLanguage,
    visitorId,
    navigationButtonTranslations
  } = props;

  const { t } = useTranslation();

  const startSurveyExecution = useStartSurveyExecution();
  const [saveInProgress, setSaveInProgress] = useState(false);

  const surveyExecutionStartHandler = async () => {
    try {
      setSaveInProgress(true);
      const info = fingerprintInfo();
      const fingerprint = {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        responderOs: `${info.os}-${info.osVersion}`,
        browser: `${info.browser}-${info.browserVersion}`,
        visitorId ,
      };

      const response = await startSurveyExecution({
        code: surveyLinkToken,
        fingerprint,
      });
      const hash = response?.data?.startSurveyExecution?.hash;
      setSurveyExecutionHash(hash);

      setSurveyResult(surveyLinkToken, hash);

      setSurveyState({ started: 1, ended: 0 });
    } catch (err) {
      if(err.message.indexOf('already completed this survey') !== -1 ){
        setIsSecondResponseError(true);
      }else{
        notification.error(t('FAILED_TO_START_SURVEY'));
      }
    } finally {
      setSaveInProgress(false);
    }
  };


  const displaySurveyIntro = ({ header, introTemplate }) => {
    return (
      <> <PublicSurveyPageStyle.ContentContainer>
      <PublicSurveyPageStyle.PublicSurveyContentContainer>
        <S.HeaderWrapper>{parse(String(getSkinWithSupportedLanguage(header || '')))}</S.HeaderWrapper>
        <S.IntroWrapper>{parse(String(getSkinWithSupportedLanguage(introTemplate || '')))}</S.IntroWrapper>
        </PublicSurveyPageStyle.PublicSurveyContentContainer>        
        {availableLanguages.length > 1 ? (
          <PublicSurveyPageStyle.FooterButtonsWrapper>
          <PublicSurveyPageStyle.ButtonsWrapper>
            <div>
              <PublicSurveyPageStyle.SurveyActionButton onClick={() => setShowSurveyLanguage(true)}>
                <PublicSurveyPageStyle.SurveyActionLogo name="survey-previous" /> {navigationButtonTranslations.previous}
              </PublicSurveyPageStyle.SurveyActionButton>
            </div>
            <div>
              {showSurveyIntro ? (
                <PublicSurveyPageStyle.SurveyActionButton onClick={() => setShowSurveyIntro(false)}>
                  {navigationButtonTranslations.next} <PublicSurveyPageStyle.SurveyActionLogo name="survey-next" /> 
                </PublicSurveyPageStyle.SurveyActionButton>
              ) : (
                <PublicSurveyPageStyle.SurveyActionButton onClick={surveyExecutionStartHandler} disabled={saveInProgress}>
                  {saveInProgress ? navigationButtonTranslations.wait : navigationButtonTranslations.next} <PublicSurveyPageStyle.SurveyActionLogo name="survey-next" /> 
                </PublicSurveyPageStyle.SurveyActionButton>
              )}
            </div>
          </PublicSurveyPageStyle.ButtonsWrapper>
          </PublicSurveyPageStyle.FooterButtonsWrapper>
        ) : (
          <PublicSurveyPageStyle.FooterButtonsWrapper>
          <S.BtnContainer addPaddingRight>
            {showSurveyIntro ? (
              <PublicSurveyPageStyle.SurveyActionButton onClick={() => setShowSurveyIntro(false)}>
                {navigationButtonTranslations.start} <PublicSurveyPageStyle.SurveyActionLogo name="survey-next" /> 
              </PublicSurveyPageStyle.SurveyActionButton>
            ) : (
              <PublicSurveyPageStyle.SurveyActionButton onClick={surveyExecutionStartHandler} disabled={saveInProgress}>
              {saveInProgress ? navigationButtonTranslations.wait : navigationButtonTranslations.start} <PublicSurveyPageStyle.SurveyActionLogo name="survey-next" /> 
              </PublicSurveyPageStyle.SurveyActionButton>
            )}
          </S.BtnContainer>
          </PublicSurveyPageStyle.FooterButtonsWrapper>
        )}
        </PublicSurveyPageStyle.ContentContainer>
      </>
    );
  };

  return (
    <div>
      {showSurveyLanguage && availableLanguages.length > 1 ? (
        <PublicSurveyLanguage
          availableLanguages={availableLanguages}
          setSelectedLanguage={setSelectedLanguage}
          selectedLanguage={selectedLanguage}
          onLanguageNext={onLanguageNext}
          navigationButtonTranslations={navigationButtonTranslations}
        />
      ) : (
        <>
         {displaySurveyIntro(surveySkin)}
        </>
      )}
    </div>
  );
};

export default React.memo(PublicSurveyIntro);
